export class Experience {
    city: string;
    currentlyEmployed: boolean;
    employer: string;
    endDate: Date;
    long: number;
    jobDescription: string;
    province: string;
    reasonForLeaving: string;
    startDate: Date;
    title: string;
    index: number;
}
